import io from "socket.io-client";
import { getExchangeRates } from "api/walletApi";
import {
  SOCKET,
  Event,
  sendNotfication,
  DEVELOPMENT,
  Game,
  SITE,
  API,
} from './Helper';
import storage from "./Storage";
import { objectEach } from "highcharts";

/**
 * Socket URL
 */
const ws = SOCKET;

getExchangeRates().then(function (res) {
  Object.keys(res).forEach(function (name, key) {
    let val = res[name];
    Game[name] = parseFloat(val);
  });
}).catch(console.error);
// fetch(api).then(function(req){
//   var res = req.formData;
//   objectEach.keys(res).forEach(function(name,key) {

//     let val = res[name];
//     Game[name] = parseFloat(val);
    
//   });
// }
// );

/**
 * Initialize Socket Connection
 */
let socket;

export const connect = (token) => {
  console.log("[Socket.js] Connecting to:", ws, "with token:", token);
  socket = io.connect(ws, {
    secure: ws.startsWith('wss'),
    transports: ['websocket'],
    withCredentials: false,
    query: {
      auth_token: token,
      user_key: storage.getKey("key"),
    },
  });
};

if (!DEVELOPMENT) {
  if (storage.getKey("mthfk") === null) {
    connect(storage.getKey("refreshToken") || storage.getKey("token"));
  }
} else {
  connect(storage.getKey("refreshToken") || storage.getKey("token"));
}

let dis = false;

socket.on("connect", () => {
  console.log("[Socket.js] Socket connected successfully! ID:", socket.id);
  Event.emit("connect");
  if (DEVELOPMENT) {
    if (dis) {
      console.clear();
    }
  }
});

/*
 * Disconnect Server
 */
socket.on("disconnect", (reason) => {
  console.warn("[Socket.js] Socket disconnected! Reason:", reason);
  Event.emit("disconnect");
  // sendNotfication(
  //   "Connection Lost, Trying to connect...",
  //   "danger",
  //   "top-center"
  // );
  dis = true;
});

/*
 * Disconnect Server for Hacker
 */
Event.on("mthfk", () => {
  if (!DEVELOPMENT) socket.disconnect();
});

export default socket;
